import type { z } from 'zod';
import { makeVaultValidatedRequest } from './make-vault-validated-request';

interface IVaultGetRequestParams<S extends z.ZodType> {
  path: string;
  schema: S;
}

export async function vaultGetRequest<S extends z.ZodType>({
  path,
  schema,
}: IVaultGetRequestParams<S>): Promise<z.infer<S>> {
  return makeVaultValidatedRequest({ method: 'GET', path, schema });
}
